// packages/shared-components/src/components/ButtonGroup/ButtonGroup.tsx
import { ButtonGroupProps } from "./types";
import { Button } from "../Button";
import styles from "./ButtonGroup.module.css";

export function ButtonGroup<T extends string | number>({
  options,
  value,
  onChange,
  size = "md",
  variant = "default",
  disabled = false,
  className = "",
}: ButtonGroupProps<T>) {
  const handleClick = (optionValue: T) => {
    if (disabled) return;
    onChange?.(optionValue);
  };

  const isActive = (optionValue: T) => value === optionValue;

  const renderOption = (
    option: T | { label: string; value: T; icon?: React.ReactNode },
    index: number
  ) => {
    const optionValue = typeof option === "object" ? option.value : option;
    const optionLabel =
      typeof option === "object" ? option.label : String(option);
    const optionIcon = typeof option === "object" ? option.icon : undefined;

    return (
      <Button
        key={index}
        size={size}
        variant={variant}
        active={isActive(optionValue)}
        disabled={disabled}
        leftIcon={optionIcon}
        onClick={() => handleClick(optionValue)}
      >
        {optionLabel}
      </Button>
    );
  };

  return (
    <div className={`${styles.buttonGroup} ${className}`}>
      {options.map(renderOption)}
    </div>
  );
}
